import { getProcedimentosConsideradosTooltipText } from 'view/acompanhamento/acompanhamento-condicao-saude/utils-acompanhamentoCondicaoSaude'

export const PROCEDIMENTOS_PRIMEIRA_CONSULTA_TOOLTIP_TEXT = getProcedimentosConsideradosTooltipText([
  'Primeira consulta odontológica programática (0301010153)',
])

export const PROCEDIMENTOS_EXODODONTIA_TOOLTIP_TEXT = getProcedimentosConsideradosTooltipText([
  'Exodontia de dente permanente (0414020138)',
  'Exodontia múltipla com alveoloplastia por sextante (0414020146)',
])

export const PROCEDIMENTOS_PREVENTIVOS_TOOLTIP_TEXT = getProcedimentosConsideradosTooltipText([
  'Aplicação de cariostático (por dente) (0101020058)',
  'Aplicação de selante (por dente) (0101020066)',
  'Aplicação tópica de flúor (individual por sessão) (0101020074)',
  'Evidenciação de placa bacteriana (0101020082)',
  'Selamento provisório de cavidade dentária (0101020090)',
  'Orientação de higiene bucal (0101020104)',
])

export const REGISTROS_ESCOVACAO_TOOLTIP_TEXT = getProcedimentosConsideradosTooltipText(
  [
    'Práticas em saúde - Escovação Dental Supervisionada',
    'Ação coletiva de escovação dental supervisionada (0101020031) ',
  ],
  {
    plural: 'Registro considerado',
    singular: 'Registros considerados',
  }
)
